import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import Stars from "@/components/Stars";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("nl-BE", { month: "long", year: "numeric" }) : "");

/** Publieke gastenboekpagina: enkel de beoordelingen die in Admin als publiek zijn
 *  aangevinkt. Blijft dus leeg tot de camping zelf iets vrijgeeft. */
export default function Gastenboek() {
  const [params] = useSearchParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = params.get("tenant") ? `?tenant=${params.get("tenant")}` : "";
    api.get(`/public/reviews${q}`)
      .then(({ data: d }) => setData(d))
      .catch((e) => { console.warn("Gastenboek ophalen mislukt", e?.message); setData({ rows: [], count: 0 }); });
  }, [params]);

  if (!data) {
    return <div className="min-h-screen bg-[#0b1623] flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-white/40" /></div>;
  }

  return (
    <div className="min-h-screen bg-[#0b1623] text-white px-5 py-16" data-testid="guestbook-public">
      <div className="mx-auto max-w-3xl">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#5BBCE6]">Gastenboek</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight">{data.camp_name || ""}</h1>
        {data.average ? (
          <div className="mt-5 flex items-center gap-3">
            <Stars value={data.average} size="lg" />
            <span className="text-2xl font-semibold tabular-nums">{data.average.toFixed(1)}</span>
            <span className="text-white/40">· {data.count}</span>
          </div>
        ) : (
          <p className="mt-5 text-white/50" data-testid="guestbook-empty">Er zijn nog geen beoordelingen vrijgegeven.</p>
        )}

        <div className="mt-12 space-y-5">
          {data.rows.map((r, i) => (
            <figure key={`${r.date}-${i}`} className="rounded-2xl bg-white/[0.04] border border-white/10 p-6"
              data-testid={`guestbook-item-${i}`}>
              <Stars value={r.overall} size="sm" />
              {r.comment && <blockquote className="mt-4 text-white/80 leading-relaxed">“{r.comment}”</blockquote>}
              <figcaption className="mt-4 text-xs text-white/40">
                {r.first_name || "Gast"} · {fmt(r.date)}
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="mt-16 text-center text-[11px] text-white/25">CampAd Pro</p>
      </div>
    </div>
  );
}
